// extracted by mini-css-extract-plugin
export default {"postList":"TF2B9ilHTk"};